import { AGATHA_ORIGIN } from "@/search/search.constants";
import stringifyParams from "@/utils/stringifyParams";

const buildRequestUrlToFetchSearchDataFromAgatha = ({
  endpoint,
  queryParameters,
}) => {
  return `${AGATHA_ORIGIN}/api/${endpoint}/${stringifyParams(queryParameters)}`;
};

export default buildRequestUrlToFetchSearchDataFromAgatha;
